import React from 'react'
import IcFb from 'assets/icons/ic-fb.png'
import IcTw from 'assets/icons/ic-twitter.png'
import IcWa from 'assets/icons/ic-wa.png'
import IcMail from 'assets/icons/ic-email.png'

export default function GroupShare() {
  return (
    <div className="grid flex-col grid-cols-2 gap-4 shareWrapper">
      <div className="flex flex-col items-center justify-center w-full py-3 text-xs font-light cursor-pointer rounded-2xl bg-blurBorder text-articleTitle">
        <img src={IcFb} alt="facebook share" width={11.56} height={20.25} />
        Faceboook
      </div>
      <div className="flex flex-col items-center justify-center w-full py-3 text-xs font-light cursor-pointer rounded-2xl bg-blurBorder text-articleTitle">
        <img src={IcTw} alt="facebook share" width={20.56} height={16.55} />
        Twitter
      </div>
      <div className="flex flex-col items-center justify-center w-full py-3 text-xs font-light cursor-pointer rounded-2xl bg-blurBorder text-articleTitle">
        <img src={IcWa} alt="facebook share" width={20.56} height={16.55} />
        Whatsapp
      </div>
      <div className="flex flex-col items-center justify-center w-full py-3 text-xs font-light cursor-pointer rounded-2xl bg-blurBorder text-articleTitle">
        <img src={IcMail} alt="facebook share" width={14.64} height={10.53} />
        Email
      </div>
    </div>
  );
}
